import { Button, Col, Row } from "antd";

type FooterProps = {
  isSaving: boolean;
  submitLabel: string;
  onBack: () => void;
  onNext: () => void;
};

export const Footer = ({
  isSaving,
  submitLabel,
  onBack,
  onNext,
}: FooterProps) => {
  return (
    <Row>
      <Col span={8} className="pr-2">
        <Button
          shape="round"
          size="large"
          onClick={onBack}
          block
          disabled={isSaving}
        >
          Back
        </Button>
      </Col>
      <Col span={16} className="pl-2">
        <Button
          shape="round"
          size="large"
          type="primary"
          onClick={onNext}
          disabled={isSaving}
          loading={isSaving}
          block
        >
          {submitLabel}
        </Button>
      </Col>
    </Row>
  );
};
